// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"964c474c","455":"77c33d96","977":"c28bd1c4"}[chunkId] + ".chunk.js";
};